/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  ExtendedFleetRolesList,
  FleetResourceAccessGroupsList,
  FleetRoleExtended,
  FleetRoleUpdateInput,
  SchemaValidationErrorResponse,
  StandardError,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Fleet Resource Access Catalog
 */
export const fleetResourceAccessCatalog = (

 signal?: AbortSignal
) => {


      return axiosClient<FleetResourceAccessGroupsList>(
      {url: `/fleets/resource-access-catalog`, method: 'GET', signal
    },
      );
    }




export const getFleetResourceAccessCatalogQueryKey = () => {
    return [
    'fleets','resource-access-catalog'
    ] as const;
    }


export const getFleetResourceAccessCatalogQueryOptions = <TData = Awaited<ReturnType<typeof fleetResourceAccessCatalog>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetResourceAccessCatalog>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetResourceAccessCatalogQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetResourceAccessCatalog>>> = ({ signal }) => fleetResourceAccessCatalog(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetResourceAccessCatalog>>, TError, TData>
}

export type FleetResourceAccessCatalogQueryResult = NonNullable<Awaited<ReturnType<typeof fleetResourceAccessCatalog>>>
export type FleetResourceAccessCatalogQueryError = ErrorType<unknown>


/**
 * @summary Fleet Resource Access Catalog
 */

export function useFleetResourceAccessCatalog<TData = Awaited<ReturnType<typeof fleetResourceAccessCatalog>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetResourceAccessCatalog>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetResourceAccessCatalogQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Fleet Role List
 */
export const fleetRoles = (
    fleetSlug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);

      return axiosClient<ExtendedFleetRolesList>(
      {url: `/fleets/${fleetSlug}/roles`, method: 'GET', signal
    },
      );
    }




export const getFleetRolesQueryKey = (fleetSlug: MaybeRefOrGetter<string>,) => {
    return [
    'fleets',fleetSlug,'roles'
    ] as const;
    }


export const getFleetRolesQueryOptions = <TData = Awaited<ReturnType<typeof fleetRoles>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetRoles>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetRolesQueryKey(fleetSlug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetRoles>>> = ({ signal }) => fleetRoles(fleetSlug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetRoles>>, TError, TData>
}

export type FleetRolesQueryResult = NonNullable<Awaited<ReturnType<typeof fleetRoles>>>
export type FleetRolesQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Fleet Role List
 */

export function useFleetRoles<TData = Awaited<ReturnType<typeof fleetRoles>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetRoles>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetRolesQueryOptions(fleetSlug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Rename Fleet Role
 */
export const updateFleetRole = (
    fleetSlug: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
    fleetRoleUpdateInput: MaybeRefOrGetter<FleetRoleUpdateInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
id = toValue(id);
fleetRoleUpdateInput = toValue(fleetRoleUpdateInput);

      return axiosClient<FleetRoleExtended>(
      {url: `/fleets/${fleetSlug}/roles/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: fleetRoleUpdateInput, signal
    },
      );
    }




export const getUpdateFleetRoleMutationKey = () => ['updateFleetRole'] as const;

export const getUpdateFleetRoleMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetRole>>, TError,UpdateFleetRoleMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateFleetRole>>, TError,UpdateFleetRoleMutationVariables, TContext> => {

const mutationKey = getUpdateFleetRoleMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFleetRole>>, UpdateFleetRoleMutationVariables> = (props) => {
          const {fleetSlug,id,data} = props ?? {};

          return  updateFleetRole(fleetSlug,id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateFleetRoleMutationResult = NonNullable<Awaited<ReturnType<typeof updateFleetRole>>>
    export type UpdateFleetRoleMutationBody = FleetRoleUpdateInput
    export type UpdateFleetRoleMutationError = ErrorType<ValidationError | StandardError>
    export type UpdateFleetRoleMutationVariables = {fleetSlug: string;id: string;data: FleetRoleUpdateInput}

    /**
 * @summary Rename Fleet Role
 */
export const useUpdateFleetRole = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetRole>>, TError,UpdateFleetRoleMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateFleetRole>>,
        TError,
        UpdateFleetRoleMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateFleetRoleMutationOptions(options), queryClient);
    }
